module.exports = __webpack_public_path__ + "static/media/Faith Based.75a04687.svg";